var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"accordion-container clearfix"},[_c('div',{staticClass:"title clearfix"},[_c('wes-question-number',{attrs:{"index":_vm.question.displayId}}),_c('p',[_vm._v(_vm._s(_vm.question.label))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }